import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function Settings({ color, size, ...props }) {
  return (
    <Svg height={size} stroke={color} viewBox="0 0 24 24" width={size} {...props}>
      <Path
        d="M19.922 7.213a1.874 1.874 0 0 0 1.065 2.571l1.265.45a1.875 1.875 0 0 1 0 3.534l-1.265.45a1.874 1.874 0 0 0-1.065 2.571L20.5 18a1.875 1.875 0 0 1-2.5 2.5l-1.213-.576a1.874 1.874 0 0 0-2.571 1.065l-.45 1.265a1.875 1.875 0 0 1-3.533 0l-.45-1.265a1.875 1.875 0 0 0-2.572-1.065L6 20.5A1.874 1.874 0 0 1 3.5 18l.576-1.213a1.874 1.874 0 0 0-1.065-2.571l-1.265-.45a1.875 1.875 0 0 1 0-3.534l1.265-.45a1.874 1.874 0 0 0 1.065-2.569L3.5 6A1.874 1.874 0 0 1 6 3.5l1.213.576a1.875 1.875 0 0 0 2.57-1.063l.45-1.265a1.875 1.875 0 0 1 3.533 0l.45 1.265a1.874 1.874 0 0 0 2.571 1.065L18 3.5A1.875 1.875 0 0 1 20.5 6Z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.499 12.001a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0-9 0"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
});
